module.exports = __webpack_public_path__ + "static/media/print-balance-t4.3bb8979a.nom";